export const findOrderMarker = (
  markers: Record<string, uui.domain.ui.map.markers.Order>,
  orderId: string,
): uui.domain.ui.map.markers.Order | undefined => {
  const marker = markers[orderId]

  return marker
}
